import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetServicePoints,
	GetServicePointsModel,
	GetServicePointsParams,
} from 'domain/usecases/private/service-points/get-service-points';

export class RemoteGetServicePoints implements GetServicePoints {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetServicePointsModel>,
	) {}

	async get({signal, ...params}: GetServicePointsParams): Promise<GetServicePointsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
			params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
